import { render, staticRenderFns } from "./bulkrtd.vue?vue&type=template&id=6ca1f208&"
import script from "./bulkrtd.vue?vue&type=script&lang=js&"
export * from "./bulkrtd.vue?vue&type=script&lang=js&"
import style0 from "./bulkrtd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports